import {
  Directive,
  effect,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { PermissionKey } from '../../core';
import { PermissionService } from '../../core/services/permission.service';

@Directive({
  selector: '[appHasPermission]',
})
export class HasPermissionDirective {
  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly permissionService = inject(PermissionService);

  readonly appHasPermission = input.required<PermissionKey | PermissionKey[]>();

  private hasView = false;

  constructor() {
    void this.permissionService.ensureInitialized();
    effect(() => {
      const permissions = this.appHasPermission();
      const allowed = Array.isArray(permissions) ? permissions : [permissions];
      const hasPermission = this.permissionService.hasAnyPermission(allowed);

      if (hasPermission && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (!hasPermission && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }
}
